import React from "react"
import HTMLNode from "../../slate-nodes/html/html-node"

export default () => {
  return {
    renderNode(props, editor, next) {
      const { node, attributes } = props
      switch (node.type) {
        case "html": {
          return (
            <HTMLNode
              node={node}
              {...node.data.toJS()}
              attributes={attributes}
              editor={editor}
            />
          )
        }
        default:
          return next()
      }
    }
  }
}
